/* Copyright (C) NewFoundry 2022 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var _classCallCheck = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ApiNormalizer = void 0;

var ApiNormalizer = /*#__PURE__*/function () {
  function ApiNormalizer() {
    _classCallCheck(this, ApiNormalizer);
  }

  _createClass(ApiNormalizer, null, [{
    key: "getEmptyNormalizedObject",
    value: function getEmptyNormalizedObject() {
      return {
        byId: {},
        allIds: []
      };
    }
  }, {
    key: "getId",
    value: function getId(entry) {
      return entry.id;
    }
  }, {
    key: "normalize",
    value: function normalize(data, existing) {
      var _this = this;

      var resp = existing || this.getEmptyNormalizedObject();

      if (Array.isArray(data)) {
        data.forEach(function (entry) {
          var id = _this.getId(entry);

          if (id) {
            resp.byId[id] = entry;
            resp.allIds.push(id);
          } else {
            if (!resp._unsorted) {
              resp._unsorted = [];
            }

            resp._unsorted.push(entry);
          }
        });

        if (resp.allIds.length === 0) {
          resp = data;
        }
      } else {
        var id = this.getId(data);

        if (id) {
          resp.byId[id] = data;
          resp.allIds.push(id);
        } else {
          resp = data;
        }
      }

      return resp;
    }
  }, {
    key: "run",
    value: function run(apiResp) {
      var _this2 = this;

      var _a;

      try {
        var resp = {};
        var data = apiResp.data;
        Object.keys(data).forEach(function (key) {
          if (!resp[key]) {
            resp[key] = _this2.getEmptyNormalizedObject();
          }

          resp[key] = _this2.normalize(data[key], resp[key]);
        });

        if ((_a = resp.attributes) === null || _a === void 0 ? void 0 : _a.byId) {
          Object.keys(resp.attributes.byId).forEach(function (id) {
            var attribute = resp.attributes.byId[id];
            var parentCategory = resp.categories.byId[attribute.categoryId];

            if (parentCategory) {
              if (!parentCategory.attributes) {
                parentCategory.attributes = [];
              }

              parentCategory.attributes.push(attribute.id);
              var properties = Object.values(resp.properties.byId);
              resp.attributes.byId[id].properties = properties.filter(function (p) {
                return p.attributeId === id;
              }).map(function (p) {
                return p.id;
              });
            }
          });
        }

        return resp;
      } catch (e) {
        console.error('Error running ApiNormalizer. Returning raw data...', e);
        return apiResp;
      }
    }
  }]);

  return ApiNormalizer;
}();

exports.ApiNormalizer = ApiNormalizer;